__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/20b1de3b23653c475b24c7f4c60889e13eb6c71f/_next/";